// libraries
import React from 'react';
import PropTypes from 'prop-types';
import fp, {flow} from 'lodash/fp';

// shared
import Toast from 'shared/components/toast';
import Icon from 'shared/components/icon';

import {watchMedia, getMedia} from 'shared/mq';

class SimpleNotification extends React.Component {
  static propTypes = {
    dismiss: PropTypes.func.isRequired,
    iconType: PropTypes.string,
    text: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node,
      PropTypes.object
    ]).isRequired,
    type: PropTypes.string.isRequired
  };

  UNSAFE_componentWillMount() {
    this.mq = watchMedia(() => {
      this.forceUpdate();
    });
  }

  firstOf = ({content, matching: mq}) => {
    const activeMediaQueries = flow(
      fp.mapKeys(fp.snakeCase),
      fp.pickBy(fp.identity),
      fp.keys,
    );

    const firstActiveMediaQueryContent = flow(
      fp.pick(activeMediaQueries(mq)),
      fp.values,
      fp.first
    );

    return firstActiveMediaQueryContent(content);
  }


  formatContent = (content) => {
    switch (typeof(content)) {
      case 'string':
        return (
          <span className="shared-notifications-message-text">
            {content}
          </span>
        );
      case 'object':
        return (
          <span className="shared-notifications-message-text">
            {this.firstOf({content, matching: getMedia()})}
          </span>
        );
      default:
        return content;
    }
  }

  render() {
    const {dismiss, iconType, text, type} = this.props;
    return (
      <Toast type={type} className="shared-notification-toast">
        {iconType && <Icon iconType={iconType} />}
        {this.formatContent(text)}
        <Icon
          iconType="times-r"
          className="shared-notifications-dismiss-notification-button"
          onClick={dismiss}
        />
      </Toast>
    );
  }
}


export default SimpleNotification;
